import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@uhg-abyss/web/ui/Link';
import { SideTab } from '@sde/widgets-core/src/common/SideTab';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useOnboarding } from '@sde/widgets-core/src/redux/resources/onboarding';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useTutorial } from '../../state/tutorial';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledListUl = styled('ul', {
  height: '85%',
  padding: '10px 20px',
});

const StyledRemovalLink = styled('div', {
  textAlign: 'center',
  borderTop: '1px solid #ccc',
});

const ContentSelectorDiv = styled('div', {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: -50,
});

const StyledText = styled('p', {
  fontSize: '14px',
  color: '$white',
  marginBottom: '0px',
});

export const TrainingTips = ({ tutorials, appKey, user }) => {
  const { tooltips } = useOnboarding.state();
  const { setOnboarding } = useOnboarding.actions();
  const [selectedTutorial, setSelectedTutorial] = useState();
  const { setTutorialActive } = useTutorial.actions();
  const [isOpen, setOpen] = useState(false);

  const removeTrainingTips = () => {
    setOnboarding(
      {
        uuid: user.uuid,
        tooltips: { [appKey]: false },
      },
      () => {
        setOpen(false);
      }
    );
  };

  const handleLinkClick = (component) => {
    setOpen(false);
    setSelectedTutorial(component.id);
    setTutorialActive(true);
  };
  const handleCloseTutorial = () => {
    setSelectedTutorial(null);
    setTutorialActive(false);
  };

  const handleTabClick = () => {
    setOpen(!isOpen);
  };

  if (!tooltips[appKey]) {
    return null;
  }
  return (
    <React.Fragment>
      <For each='tutorial' of={tutorials}>
        {React.createElement(tutorial.component, {
          key: tutorial.id,
          isActive: tutorial.id === selectedTutorial,
          onClose: handleCloseTutorial,
        })}
      </For>
      <SideTab
        isOpen={isOpen}
        onClick={handleTabClick}
        offset={320}
        before={<IconSymbol icon='help' size={20} color='white' />}
        after={
          isOpen ? (
            <IconSymbol
              icon='keyboard_arrow_down'
              size={30}
              color='$primary2'
            />
          ) : (
            <IconSymbol icon='keyboard_arrow_up' size={30} color='$primary2' />
          )
        }
        content={
          <React.Fragment>
            <ContentSelectorDiv data-testid='training-tips-flyout' />
            <StyledListUl>
              <For each='tutorial' of={tutorials}>
                <li
                  key={tutorial.id}
                  style={{
                    height:
                      tutorials.length < 4
                        ? `${50 / tutorials.length}%`
                        : `${100 / tutorials.length}%`,
                  }}
                >
                  <Link
                    onClick={() => handleLinkClick(tutorial)}
                    styles={{
                      button: (base) => ({
                        ...base,
                        textAlign: 'left',
                      }),
                    }}
                  >
                    {tutorial.name}
                  </Link>
                </li>
              </For>
            </StyledListUl>
            <StyledRemovalLink>
              <Link
                onClick={removeTrainingTips}
                size={14}
                styles={{
                  button: (base) => ({
                    ...base,
                    fontWeight: 'normal',
                  }),
                }}
                isDisabled={user.isTechnicalUser}
              >
                Remove Training Tips
              </Link>
            </StyledRemovalLink>
          </React.Fragment>
        }
      >
        <StyledText>Training Tips</StyledText>
      </SideTab>
    </React.Fragment>
  );
};

TrainingTips.propTypes = {
  tutorials: PropTypes.arrayOf(PropTypes.shape({})),
  appKey: PropTypes.string,
};

TrainingTips.defaultProps = {
  tutorials: [],
  appKey: null,
};
